/**
 * Structural constants of the Subagents module (VOX-329). No display text here —
 * labels are resolved from i18n by the components.
 */

/** Route segment of the module, under the agent's `myassistant` routes. */
export const SUBAGENTS_ROUTE_SEGMENT = 'subagents';

/** Value of a toolbar select that applies no filter ("All skills", "All voices"). */
export const NO_FILTER = 'all';

/** Longest subagent name the create form accepts. */
export const SUBAGENT_NAME_MAX_LENGTH = 80;
